// extracted by mini-css-extract-plugin
module.exports = {"initialsIcon":"initial-icon-new_initialsIcon__R4ZmL"};